// Cloudflare Turnstile ile ilgili paylaşılan sabitler ve yardımcılar.
// Widget'ın kendisi components/Turnstile/Turnstile.jsx içinde.

// Backend'in token'ı beklediği alan adı (captchaMiddleware.TOKEN_FIELD).
export const TOKEN_FIELD = 'captchaToken';

// Bal küpü alanı (captchaMiddleware.HONEYPOT_FIELD). 'website' adı iş
// ortaklığı formunda gerçek bir alan olduğu için kullanılamaz.
export const HONEYPOT_FIELD = 'additionalInfo';

// Site anahtarı gizli değil: HTML'e gömülmek üzere tasarlanmış.
// Modül seviyesinde sabitlemek yerine fonksiyonla okuyoruz ki test ortamında
// değiştirilebilsin; CRA yine de derleme sırasında değeri gömer.
export const getTurnstileSiteKey = () => process.env.REACT_APP_TURNSTILE_SITE_KEY || '';

// Anahtar tanımlı değilse widget hiç basılmaz ve formlar token beklemez.
// Backend de aynı durumda doğrulamayı atladığı için iki taraf uyumlu kalır:
// anahtarsız ortamda site eskisi gibi çalışır, sadece korumasız olur.
export const isTurnstileEnabled = () => getTurnstileSiteKey() !== '';

// Form gönderilirken payload'a eklenecek alanlar. Doğrulama kapalıysa hiçbir
// şey eklenmez, çünkü backend de bu alanları aramıyor.
export const buildCaptchaPayload = (token, honeypotValue = '') => {
  if (!isTurnstileEnabled()) return {};

  return {
    [TOKEN_FIELD]: token || '',
    [HONEYPOT_FIELD]: honeypotValue,
  };
};
